import React from "react";

const Sidebar = props => (
  <svg viewBox="0 0 27 23" fill="none" {...props}>
    <path
      d="M8.064 3.265c.393 0 .785.392.785.785 0 .442-.393.786-.785.786H4.922a.775.775 0 01-.785-.786c0-.393.343-.785.785-.785h3.142zM4.137 7.192c0-.393.343-.786.785-.786h3.142c.393 0 .785.393.785.786 0 .442-.393.785-.785.785H4.922a.775.775 0 01-.785-.785zm3.927 2.356c.393 0 .785.393.785.785 0 .442-.393.786-.785.786H4.922a.775.775 0 01-.785-.786c0-.392.343-.785.785-.785h3.142zM22.986.123c1.718 0 3.142 1.424 3.142 3.142v15.708a3.132 3.132 0 01-3.142 3.141H4.136c-1.766 0-3.14-1.374-3.14-3.141V3.265A3.132 3.132 0 014.135.123h18.85zm0 1.571H11.991v18.85h10.995c.835 0 1.571-.688 1.571-1.571V3.265c0-.835-.736-1.571-1.57-1.571zm-20.42 1.57v15.709c0 .883.687 1.57 1.57 1.57h6.284V1.694H4.137c-.884 0-1.57.736-1.57 1.57z"
      fill="currentColor"
    />
  </svg>
);

export default Sidebar;
